const RUNTIME_ENV =
  (typeof window !== "undefined" && window.process && window.process.env) || {};

export const ENV = {
  ...process.env,
  ...RUNTIME_ENV,
};

export const URL = {
  REACT_APP_HLS_BASE_URL: ENV.REACT_APP_HLS_BASE_URL || "",
  REACT_APP_PUBLIC_ASSETS_BASE_URL:
    ENV.REACT_APP_PUBLIC_ASSETS_BASE_URL || "https://assets.yourrighthand.ai",
};

const config = {
  ENV,
  URL,
};

export default config;
